import Vue from 'vue'
import Router from 'vue-router'

import Header from '@/components/includes/Header'
import Footer from '@/components/includes/Footer'

import Top from '@/components/Top.vue'

import Regist from '@/components/Regist.vue'
import Verified from '@/components/Verified.vue'

import Initial from '@/components/Initial.vue'

import ResetPassword from '@/components/ResetPassword.vue'

import Contact from '@/components/Contact.vue'

import Privacy from '@/components/Privacy.vue'
import Terms from '@/components/Terms.vue'
import Commerce from '@/components/Commerce.vue'

import Unauthorized from '@/components/Unauthorized'

import NotFound from '@/components/NotFound'

// import { authGuard } from '../plugins/auth'

Vue.component('Header', Header)
Vue.component('Footer', Footer)

Vue.use(Router)

export default new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  base: '/',
  routes: [
    { path: '/index.html', redirect: '/' },
    { path: '/', name: 'Top', component: Top },
    { path: '/regist', name: 'Regist', component: Regist },
    { path: '/verified', name: 'Verified', component: Verified },
    { path: '/initialSetting', name: 'Initial', component: Initial },
    { path: '/resetPassword', name: 'Reset Password', component: ResetPassword },
    { path: '/contact', component: Contact },
    { path: '/privacy', component: Privacy },
    { path: '/terms', component: Terms },
    { path: '/commerce', component: Commerce },
    { path: '/unauthorized', component: Unauthorized },
    { path: '*', component: NotFound }
  ]
})
